import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {
  fr: {
    msg_obligatoire: 'Ce champ est obligatoire',
    msg_lg_mini: 'Ce champs doit contenir un minimum de {nb} caractères',
    msg_champ_courriel: 'Ce champ doit contenir une adresse courriel',
    msg_champ_numeric: 'Ce champ doit contenir une valeur numérique',
    msg_mdp_identique: 'Les mots de passe doivent être identiques',
    msg_mdp_regles:
      'Le mot de passe doit contenir au moins une lettre minuscule, une lettre majuscule et un chiffre.',
    login_ouvrir: 'Ouverture de session',
    login_codeUsager: 'Code usager',
    login_pwd: 'Mot de passe',
    login_connecter: 'Connexion',
    login_connecter_bouton: 'Se connecter',

    mdp_oublie_lien: 'Mot de passe oublié?',
    mdp_oublie_titre: 'Mot de passe oublié',
    mdp_oublie_into:
      'Veuillez inscrire votre adresse courriel ainsi que votre numéro de client SAQ',
    mdp_oublie_courriel: 'Courriel',
    mdp_oublie_noclient: 'Numéro de client SAQ',
    mdp_oublie_submit_btn: 'Réinitialiser mon mot de passe',
    mdp_oublie_confirmation_envoi_token:
      "Si les informations fournis correspondent, un courriel sera envoyé à l'adresse fournie avec les instructions suivantes pour réinitialiser votre mot de passe. Si vous ne recevez aucun courriel et que vous pensez que les informations sont exactes, veuillez nous contacter.",
    mdp_oublie_reinitialiser_titre: 'Réinitialisation de votre mot de passe',
    mdp_oublie_reinitialiser_token_not_found:
      "Le numéro de client n'a pu être retrouvé. Utilisez le lien ci-bas pour en obtenir un nouveau.",
    mdp_oublie_reinitialiser_mot_de_passe: 'Nouveau mot de passe',
    mdp_oublie_reinitialiser_mot_de_passe2: 'Confirmation du mot de passe',
    mdp_oublie_btn_sauvegarder: 'Sauvegarder',
    mdp_oublie_reinitialiser_succes:
      'Votre mot de passe a été réinitialisé avec succès!',
    mdp_oublie_reinitialiser_erreur_invalid_token:
      'Le jeton de réinitialisation utilisé semble être expiré ou non existant. Vous pouvez en obtenir un nouveau sur la page de mot de passe oublié.',
    mdp_oublie_reinitialiser_succes_instructions:
      "Vous pouvez maintenant vous connecter à partir de la page d'accueil.",
    mdp_oublie_reinitialiser_erreur_compte_verouille:
      'Votre compte a été vérouillé par un administrateur. Veuillez nous contacter pour remédier à la situation.',

    no_client_saq: 'Numéro de client SAQ',
    profil_modifier_mdp_lien: 'Modifier',
    profil_modifier_mdp_popup_titre: 'Modification du mot de passe',
    profil_modifier_mdp_popup_ancien_mdp: 'Ancien mot de passe*',
    profil_modifier_mdp_popup_nouveau_mdp: 'Nouveau mot de passe*',
    profil_modifier_mdp_popup_confirmation_mdp: 'Confirmation du mot de passe*',
    profil_modifier_mdp_popup_sauvegarder: 'Sauvegarder',
    profil_modifier_mdp_popup_annuler: 'Annuler',
    profil_modifier_mdp_popup_champs_requis: 'indique un champs requis',
    profil_modifier_mdp_popup_ancienMdp_invalide:
      'Votre ancien mot de passe ne correspond pas, veuillez réassayer à nouveau.',
    profil_modifier_mdp_popup_statut_invalide:
      'Votre compte est vérouillé, veuillez nous contacter pour remédier à la situation',
    profil_modifier_mdp_popup_succes:
      'Votre mot de passe a été modifié avec succès!'
  },
  en: {
    msg_obligatoire: 'This field is required',
    msg_lg_mini: 'This field must contain at least {nb} characters',
    msg_champ_courriel: 'This field must contain an email address',
    msg_champ_numeric: 'This field must contain a numerical value',
    msg_mdp_identique: 'The passwords must be identical',
    msg_mdp_regles:
      'The password must have at least a lowercase letter, an uppercase letter and a number.',
    login_ouvrir: 'Open session',
    login_codeUsager: 'User ID',
    login_pwd: 'Password',
    login_connecter: 'Connect',
    login_connecter_bouton: 'Se connecter',

    mdp_oublie_lien: 'Forgot your password?',
    mdp_oublie_titre: 'Forgotten password',
    mdp_oublie_into:
      'Please enter your email address and your SAQ client number',
    mdp_oublie_courriel: 'Courriel',
    mdp_oublie_noclient: 'SAQ Client number',
    mdp_oublie_submit_btn: 'Reset my password',
    mdp_oublie_confirmation_envoi_token:
      'If the provided informations match, an email will be sent to the provided address with further instructions to reset your password. If you do not receive an email and you believe the informations are correct, please contact us.',
    mdp_oublie_reinitialiser_titre: 'Reset your password',
    mdp_oublie_reinitialiser_token_not_found:
      'The token you have used is either expired or has not been found. Use the link below to obtain a new one.',
    mdp_oublie_reinitialiser_mot_de_passe: 'New Password',
    mdp_oublie_reinitialiser_mot_de_passe2: 'Password Confirm',
    mdp_oublie_btn_sauvegarder: 'Save',
    mdp_oublie_reinitialiser_succes:
      'Your password has been reset successfully!',
    mdp_oublie_reinitialiser_erreur_invalid_token:
      'The reset token you are using seems to have expired or does not exist.',
    mdp_oublie_reinitialiser_succes_instructions:
      'You can now access the application via the login page.',
    mdp_oublie_reinitialiser_erreur_compte_verouille:
      'Your account has been locked by an administrator. Please contact us to fix the situation.',

    profil_modifier_mdp_lien: 'Edit',
    profil_modifier_mdp_popup_titre: 'Change your password',
    profil_modifier_mdp_popup_ancien_mdp: 'Current password*',
    profil_modifier_mdp_popup_nouveau_mdp: 'New password*',
    profil_modifier_mdp_popup_confirmation_mdp: 'Confirm new password*',
    profil_modifier_mdp_popup_sauvegarder: 'Save',
    profil_modifier_mdp_popup_annuler: 'Cancel',
    profil_modifier_mdp_popup_champs_requis: 'indicates a required field',
    profil_modifier_mdp_popup_ancienMdp_invalide:
      "Your current password doesn't match. Please try again.",
    profil_modifier_mdp_popup_statut_invalide:
      'Your account is locked. Please contact us to fix the situation.',
    profil_modifier_mdp_popup_succes:
      'Your password has been changed successfully!'
  }
}

const i18n = new VueI18n({
  locale: 'fr',
  fallbackLocale: 'en',
  messages
})

export default i18n
